if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();
        this.setMobileButtonRoles();

        this.addEventListener("change", () => {
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          const mainVariantInput = this.mainProductForm && this.mainProductForm.querySelector('[name="id"]');
          if (mainVariantInput) {
            mainVariantInput.value = selectedVariantId;
            mainVariantInput.setAttribute("data-selected-variant", selectedVariantId);
          }
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
          this.setMobileButtonRoles();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
          this.setMobileButtonRoles();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;

        const mobileBuyNow = this.container.querySelector("[data-sticky-buy-now]");
        if (mobileBuyNow) {
          mobileBuyNow.addEventListener("click", (e) => {
            e.preventDefault();
            const productSection = this.closest(".m-main-product") || document;
            const hasStickyQty = this.container.dataset.mobileAtcMode === "scroll";
            const stickyQtyInput = hasStickyQty ? this.querySelector('[name="quantity"]') : null;
            if (stickyQtyInput) {
              const mainQtyInput = Array.from(productSection.querySelectorAll('[name="quantity"]')).find(
                (input) => !this.container.contains(input)
              );
              if (mainQtyInput && mainQtyInput.value !== stickyQtyInput.value) {
                mainQtyInput.value = stickyQtyInput.value;
                mainQtyInput.dispatchEvent(new Event("input", { bubbles: true }));
                mainQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
            const existingBuyNow = productSection.querySelector("[data-mkup-buynow]");
            if (existingBuyNow && !existingBuyNow.disabled) {
              existingBuyNow.click();
              return;
            }
            if (this.hasCustomFields && typeof validateForm === "function" && validateForm(this.mainProductInfo).length > 0) {
              __scrollToTop(this.mainProductForm);
              return;
            }
            const variantInput = this.querySelector(this.selectors.variantIdSelect);
            const variantId = variantInput ? String(variantInput.value || "") : "";
            if (!variantId) {
              if (this.mainProductInfo) this.mainProductInfo.scrollIntoView({ behavior: "smooth", block: "center" });
              return;
            }
            const mainForm = this.mainProductForm && this.mainProductForm.querySelector("form");
            const quantityInput = stickyQtyInput || (mainForm && mainForm.querySelector('[name="quantity"]')) || this.querySelector('[name="quantity"]');
            const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
            const routes = window.Shopify && window.Shopify.routes;
            const rootBase = routes && routes.root ? String(routes.root).replace(/\/$/, "") : "";
            window.location.href = rootBase + "/cart/" + variantId + ":" + quantity;
          });
        }

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        const isScrollMode = ["scroll", "fixed_qty"].includes(this.container.dataset.mobileAtcMode);

        if ("IntersectionObserver" in window && isScrollMode) {
          // Show the bar only after the main Add to cart / Buy now block has been scrolled past (above the viewport).
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const topEdge = entry.rootBounds ? entry.rootBounds.top : headerHeight;
                const passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= topEdge;
                this.container.style.setProperty("--m-translate-y", passed ? "0" : "100%");
                document.documentElement.classList[passed ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: 0, rootMargin: `-${headerHeight}px 0px 0px 0px` }
          );
        } else if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        if (this.observer) {
          let target = this.mainProductForm;
          if (["scroll", "fixed_qty"].includes(this.container.dataset.mobileAtcMode)) {
            const productSection = this.closest(".m-main-product") || document;
            target = productSection.querySelector(".main-product__block-buy_buttons") || this.mainProductForm;
          }
          this.observer.observe(target);
          this.observeTarget = target;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }

      setMobileButtonRoles() {
        const productForm = this.querySelector(".sticky-atc-form");
        const addButton = productForm && productForm.querySelector('[name="add"]');
        const buyNowButton = this.querySelector("[data-sticky-buy-now]");
        if (!addButton || !buyNowButton) return;

        const isMobile = window.matchMedia
          ? window.matchMedia("(max-width: 767px)").matches
          : window.innerWidth < 768;
        if (!isMobile) {
          const desktopAddToCartIsPrimary = !addButton.classList.contains("show-dynamic-checkout");
          addButton.classList.toggle("m-button--primary", desktopAddToCartIsPrimary);
          addButton.classList.toggle("m-button--secondary", !desktopAddToCartIsPrimary);
          buyNowButton.classList.remove("m-button--primary");
          buyNowButton.classList.add("m-button--secondary");
          return;
        }

        if (this.container.dataset.mobileAtcMode === "fixed_qty") {
          // Colors for this mode come from CSS variables, so drop theme primary/secondary classes (and tag-color targeting).
          [addButton, buyNowButton].forEach((btn) => {
            btn.classList.remove("m-button--primary", "m-button--secondary");
          });
          return;
        }

        const primaryButton = this.container.dataset.mobilePrimaryButton || "buy_now";
        const addToCartIsPrimary = primaryButton === "add_to_cart";
        addButton.classList.toggle("m-button--primary", addToCartIsPrimary);
        addButton.classList.toggle("m-button--secondary", !addToCartIsPrimary);
        buyNowButton.classList.toggle("m-button--primary", !addToCartIsPrimary);
        buyNowButton.classList.toggle("m-button--secondary", addToCartIsPrimary);
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');
        const mobileBuyNow = productForm.querySelector("[data-sticky-buy-now]");

        if (!addButton) return;

        if (disable) {
          if (mobileBuyNow) mobileBuyNow.setAttribute("disabled", "disabled");
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          if (mobileBuyNow) mobileBuyNow.removeAttribute("disabled");
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCart;
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, async (variant) => {
          if (!variant) return;
          variantInput.value = variant.id;
          const mainVariantInput = this.mainProductForm && this.mainProductForm.querySelector('[name="id"]');
          if (mainVariantInput) {
            mainVariantInput.value = variant.id;
            mainVariantInput.setAttribute("data-selected-variant", variant.id);
          }
          this.currentVariant = this.variantData.find((item) => item.id === Number(variant.id));
          this.updateButton(
            !this.currentVariant || !this.currentVariant.available,
            this.currentVariant && !this.currentVariant.available ? window.MinimogStrings.soldOut : ""
          );
        });
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
